export default __webpack_public_path__ + "static/media/Minuta-orange.ac0fc601.svg";